export const accountUserType = {
  COMPANY: "COMPANY",
  LANDLORD: "LANDLORD",
};

export const CONTACT_OUR_SALES_TEAM_LINK = "https://www.canopy.rent/request-form";
